import baseWorkloadApi from './baseWorkloadApi';

export interface WaStatsParams {
  startDate?: string;
  endDate?: string;
  businessUnitId?: number | null;
}

export interface FailedByErrorItem {
  error: string;
  count: number;
}

export interface FailedByTemplateNameItem {
  templateName: string;
  count: number;
  /** Present when aggregating across all BUs */
  businessUnitId?: number;
  businessUnitName?: string;
}

export interface WaStatsTrendPoint {
  day: string;
  templatesSent: number;
  templatesFailed: number;
}

export interface WaStats {
  templatesSent: number;
  templatesFailed: number;
  failedPercent: number;
  trend: WaStatsTrendPoint[];
  failedByError: FailedByErrorItem[];
  failedByTemplateName: FailedByTemplateNameItem[];
}

const waStatsApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getWaStats: build.query<WaStats, WaStatsParams | undefined>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params?.startDate) searchParams.set('startDate', params.startDate);
        if (params?.endDate) searchParams.set('endDate', params.endDate);
        if (params?.businessUnitId != null) {
          searchParams.set('businessUnitId', String(params.businessUnitId));
        }
        const query = searchParams.toString();
        return query ? `/admin/waStats?${query}` : '/admin/waStats';
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetWaStatsQuery } = waStatsApi;
